import { NAV_LINKS } from "./TopBar";
import { ACADEMY, hasPhone, hasAddress } from "@/config/academy";

export const Footer = () => {
  return (
    <footer className="py-12 bg-black text-stone-400 text-xs font-mono border-t border-emerald-950" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="text-white font-bold uppercase">SQUARE // 64 {ACADEMY.name}</div>
        <div className="flex space-x-6 text-stone-400">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href} className="hover:text-white transition-colors">
              {link.label.split(" ")[0]}
            </a>
          ))}
          <a href="#contact" className="hover:text-white transition-colors" data-testid="footer-contact-link">
            Contact
          </a>
        </div>
        <div className="text-center md:text-right">
          <div>Strategic chess instruction &amp; tournament development</div>
          <div className="mt-1 text-stone-500" data-testid="footer-contact-line">
            {hasPhone && <span>{ACADEMY.phoneDisplay || ACADEMY.phone}</span>}
            {hasPhone && hasAddress && <span> &middot; </span>}
            {hasAddress && <span>{ACADEMY.address}</span>}
            {!hasPhone && !hasAddress && <span>Phone &amp; address to be added</span>}
          </div>
        </div>
      </div>
    </footer>
  );
};
